import styled from 'styled-components';
import { Button } from 'components';

export const FullScreenButtonStyled = styled(Button)`
  && {
    padding: 8px;
  }
`;
